import { MTableEditField } from '@material-table/core';
import Done from '@mui/icons-material/Done';
import Remove from '@mui/icons-material/Remove';
import React from 'react';

export default (user, units) => {
  const columns = [

    {
      title: 'Sub Tipo',
      field: 'subtype',
      editable: 'never',
      width: 200,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
    },
    {
      title: 'Nome',
      field: 'name',
      editable: 'never',
      width: 400,
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'left',
      },
    },
    {
      title: 'Valor',
      field: 'value',
      initialEditValue: '',
      width: 90,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
    },
    {
      title: 'Unidade',
      field: 'unit_id',
      // `N/A` when there is no unit, which is what this column has been trying to
      // say since it was written. It used to say it as `lookup: { '': 'N/A' }`,
      // and that key can never have matched: `unit_id` is an INTEGER, null on
      // 6818 of 8723 rows, and material-table resolves a lookup as
      // `lookup[value]` - so `lookup[null]` asks for the key `"null"` and the
      // cell drew empty. Not a case that broke; a case that never worked.
      //
      // `emptyValue` is the library's own field for exactly this, and it is
      // chosen over a `render` on purpose: a render has to name `unit_id` by
      // hand, and a hand-written key that drifts from its column is the defect
      // shape that drew a dash on every row of five other columns this week.
      // This one names no field, so it cannot come apart from one.
      //
      // The `''` below stays. It matches nothing at display time - it never
      // could - but it is also the entry that puts an `N/A` option in the
      // edit select, and removing it would take away the only way to say a
      // condition has no unit. That is a different change from this one.
      emptyValue: 'N/A',
      lookup: { '': 'N/A', ...units },
      initialEditValue: null,
      width: 200,
      headerStyle: {
        textAlign: 'left'
      },
      cellStyle: {
        textAlign: 'left'
      }
    },
    {
      title: 'OK',
      field: 'ok_flag',
      type: 'boolean',
      sorting: false,
      maxWidth: 90,
      minWidth: 90,
      initialEditValue: 'false',
      headerStyle: {
        textAlign: 'center'
      },
      cellStyle: {
        textAlign: 'center'
      },
      lookup: {
        true: <Done style={{ height: 16, width: 16 }}/>,
        false: <Remove style={{ height: 16, width: 16 }}/>
      },
      render: rowData => rowData.ok_flag ?
        <Done style={{ height: 16, width: 16 }}/> :
        <Remove style={{ height: 16, width: 16 }}/>
    },
    {
      title: 'Notas',
      field: 'notes',
      initialEditValue: '',
      sorting: false,
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
      width: 400
    },
  ];

  const columnsAdmin = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      width: 100,
    },
    ...columns
  ];

  return user.superuser ? columnsAdmin : columns;
};
